export const FINANCE_MODULE_GROUPS = [
  {
    title: 'Análisis y control',
    modules: [
      { key: 'dashboard', label: 'Dashboard Finance', description: 'Resumen ejecutivo de finanzas', link: 'finance/dashboard', icon: 'fas fa-chart-pie' },
      { key: 'cost_centers', label: 'Centros de costo', description: 'Asignación y análisis por centro', link: 'finance/cost-centers', icon: 'fas fa-sitemap' },
      { key: 'budgets', label: 'Presupuestos', description: 'Planificación y comparación presupuestaria', link: 'finance/budgets', icon: 'fas fa-calculator' },
      { key: 'ot_profitability', label: 'Rentabilidad OT', description: 'Margen y rentabilidad por orden de trabajo', link: 'finance/ot-profitability', icon: 'fas fa-industry' },
    ],
  },
  {
    title: 'Cobros',
    modules: [
      { key: 'accounts_receivable', label: 'Cuentas por cobrar', description: 'Documentos y pagos de clientes', link: 'finance/ar', icon: 'fas fa-hand-holding-usd' },
      { key: 'collections', label: 'Cobranza', description: 'Gestión de gestiones de cobro', link: 'finance/collections', icon: 'fas fa-phone-volume', dependsOn: ['accounts_receivable'] },
    ],
  },
  {
    title: 'Pagos y tesorería',
    modules: [
      { key: 'accounts_payable', label: 'Cuentas por pagar', description: 'Obligaciones con proveedores', link: 'finance/ap', icon: 'fas fa-file-invoice' },
      { key: 'treasury', label: 'Tesorería', description: 'Cuentas bancarias y movimientos', link: 'finance/treasury', icon: 'fas fa-university' },
      { key: 'reconciliation', label: 'Conciliación', description: 'Cartola bancaria y match de movimientos', link: 'finance/reconciliation', icon: 'fas fa-balance-scale', dependsOn: ['treasury'] },
      { key: 'cashflow', label: 'Flujo de caja', description: 'Proyección y saldos futuros', link: 'finance/cashflow', icon: 'fas fa-water' },
    ],
  },
]

export const FINANCE_MODULE_LINKS = FINANCE_MODULE_GROUPS
  .flatMap(group => group.modules)
  .reduce((acc, mod) => {
    acc[mod.link] = mod.key
    return acc
  }, {})

export const DEFAULT_FINANCE_MODULES = FINANCE_MODULE_GROUPS
  .flatMap(group => group.modules)
  .reduce((acc, mod) => {
    acc[mod.key] = true
    return acc
  }, {})

export function normalizeFinanceModules(raw) {
  const merged = { ...DEFAULT_FINANCE_MODULES }
  if (raw && typeof raw === 'object') {
    Object.keys(DEFAULT_FINANCE_MODULES).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(raw, key)) {
        merged[key] = !!raw[key]
      }
    })
  }
  return merged
}

export function isFinanceModuleEnabled(company, moduleKey) {
  if (!company || !company.finance_enabled) return false
  const modules = normalizeFinanceModules(company.finance_modules)
  return !!modules[moduleKey]
}

export function financeModuleKeyFromPath(path) {
  if (!path) return null
  const normalized = String(path).replace(/^\//, '')
  if (!normalized.startsWith('finance/')) return null
  return FINANCE_MODULE_LINKS[normalized] || null
}

export function isFinanceMenuItemVisible(company, link) {
  if (!link || !String(link).startsWith('finance/')) return true
  if (!company || !company.finance_enabled) return false
  const moduleKey = FINANCE_MODULE_LINKS[link]
  if (!moduleKey) return true
  return isFinanceModuleEnabled(company, moduleKey)
}

export function createDefaultFinanceModules() {
  return { ...DEFAULT_FINANCE_MODULES }
}
